import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import StructureStyled from "./StructureStyled";
import { useAppSelector } from "../../store/hooks";
import { NavLink } from "react-router-dom";
import useStructures from "../../hooks/useStructures/useStructures";
import { StructureStructure } from "../../types";
import { useTranslation } from "../../i18n/hooks/useTranslation";

interface StructureProps {
  structure: StructureStructure;
}

const Structure = ({
  structure: { ele, name, categories, ubication, image, id },
}: StructureProps): JSX.Element => {
  const {
    user: { isLogged },
  } = useAppSelector((state) => state);

  const { deleteStructure } = useStructures();
  const { t } = useTranslation();

  return (
    <StructureStyled className="structure">
      <NavLink to={`/structure/${id}`} className="structure__wrap">
        <link rel="preload" href={image as string} as="image" />
        <img
          className="structure__image"
          width={268}
          height={200}
          alt={t("structure.altImage", { name })}
          src={(image as string) || "images/no-photo.jpg"}
        />
        <h2 className="structure__title">{name}</h2>
        <ul className="structure__info">
          <li>
            <FontAwesomeIcon name="elevation" icon={solid("mountain")} />
            <span>
              {ele ?? " - "} {t("structure.meters")}
            </span>
          </li>
          <li>
            <FontAwesomeIcon name="elevation" icon={solid("layer-group")} />
            <span>{categories.toString()}</span>
          </li>
          <li>
            <FontAwesomeIcon name="elevation" icon={solid("home")} />
            <span>{ubication}</span>
          </li>
        </ul>
      </NavLink>

      {isLogged && (
        <span className="structure__buttons">
          <NavLink
            aria-label={t("actions.modify")}
            to={`structure/edit/${name}/${id}`}
          >
            <FontAwesomeIcon name="elevation" icon={solid("edit")} />
          </NavLink>
          <button
            aria-label={t("actions.delete")}
            onClick={() => deleteStructure(id)}
          >
            <FontAwesomeIcon name="elevation" icon={solid("trash")} />
          </button>
        </span>
      )}
    </StructureStyled>
  );
};

export default Structure;
